import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    list: new Map(),
    initialized: false
});
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'SIMULATIONENR__INIT_PROJECTS':
            return core.initProjects(state, action.projects);
        case 'SIMULATIONENR__SET_PROJECTDETAILS':
            return core.setProjectDetails(state, action.project);
        case 'SIMULATIONENR__SET_PROJECTS':
            return core.setProjects(state, action.projects);
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./environments/simulationenr/data/Projects/reducer.js